<template>
  <div class="oder_management fullheight">
    <el-main ref="tablePanel" class="fullheight">
      <div class="top_search">
        <el-row style="height: 100%; width: 100%">
          <el-col :span="16">
            <el-button size="small" type="primary" @click="addNotice">新增</el-button>
            <el-button size="small" @click="del">删除</el-button>
          </el-col>
          <el-col :span="8" class="col_style">
            <el-input v-model="code" @change="loadData" :clearable="true" placeholder="请输入公告名称">
              <el-button slot="append" type="primary" @click="loadData">搜索</el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>

      <div class="table_content">
        <el-table
          ref="ecoTable"
          :style="{
            height: `${tableMaxHeight}` + 'px'
          }"
          :max-height="tableMaxHeight"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" width="55"> </el-table-column>
          <el-table-column prop="heading" label="公告名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link type="primary" @click="preview(scope.row)">{{ scope.row.heading }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="send_obj" label="发送地址" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.send_obj == 0 ? '用户端' : scope.row.send_obj == 1 ? '管理端' : '' }}</template>
          </el-table-column>
          <el-table-column prop="create_time" label="编制时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="create_user" label="编制人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="is_send" label="状态" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.is_send == 0 ? '未发布' : scope.row.is_send == 1 ? '已发布' : '' }}</template>
          </el-table-column>
          <el-table-column prop="name" label="操作" v-if="tenantId == '-1'">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="edit(scope.row.id)" v-if="scope.row.is_send == 0" style="margin-right: 10px">编辑 </el-link>
              <!-- <el-button
                type="text"
                @click="send(scope.row.id)"
                v-if="scope.row.is_send == 0"
                >发布</el-button
              > -->
              <el-popover placement="bottom" width="160" v-model="scope.row.visible">
                <p>确定发布此公告？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.visible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="send(scope.row.id)">确定</el-button>
                </div>
                <el-link type="primary" :underline="false" slot="reference" v-if="scope.row.is_send == 0">发布</el-link>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="page_bean">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 50, 100, 500]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-main>
    <notice-form v-if="show" :show="show" :id="id" @close="close"></notice-form>
    <notice-detail :show="noticeShow" :form="noticeFrom" @close="closeNotice"></notice-detail>
  </div>
</template>

<script>
import utils from '@/utils.js'
import noticeForm from './noticeForm.vue'
import noticeDetail from '@/views/system/components/noticeDetail.vue'
export default {
  components: { noticeDetail, noticeForm },
  data() {
    return {
      tenantId: '-1',
      dateRangeVal: '',
      code: '',
      tabsVal: '3,4',
      tableData: [],
      tableMaxHeight: 400,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      orderId: '',
      paymentId: '',
      tabList: [],
      show: false,
      id: '',
      selectedVal: [],
      visible: false,
      noticeFrom: {},
      noticeShow: false
    }
  },
  mounted() {
    this.loadData()
    this.calcTableHeight()
    this.$root.$on('resize', () => {
      this.calcTableHeight(500)
      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
      })
    })
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
  },
  methods: {
    //新增系统公告
    addNotice() {
      this.id = ''
      this.show = true
    },
    //编辑系统公告
    edit(id) {
      this.id = id
      this.show = true
    },
    close() {
      this.show = false
      this.loadData()
    },
    //发布公告
    send(id) {
      this.$http.post('${business}/system/sys_bulletin/send?id=' + id).then((res) => {
        if (res.data.state) {
          this.$message.info('发布成功！')
        } else {
          this.$message.error('发布失败！')
        }
        this.loadData()
      })
    },
    //删除
    del() {
      if (this.selectedVal && this.selectedVal.length > 0) {
        let arr = []
        this.selectedVal.forEach((item) => {
          arr.push(item.id)
        })
        this.$http.remove('${business}/system/sys_bulletin/?ids=' + arr).then((res) => {
          if (res.data.state) {
            this.$message.info('删除成功！')
            this.loadData()
          }
        })
      } else {
        this.$message.info('请先选择数据！')
      }
    },
    //千分位格式化
    numberFormatter(row, column) {
      var val = row[column.property]
      if (val == undefined) {
        return ''
      }
      return utils.dataTransform(val.toString())
    },
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        textAlign: 'center',
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
      return obj
    },
    //列表样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (str.indexOf('金额') > -1 || str.indexOf('收款') > -1) {
          return 'text-align:right'
        } else {
          return 'text-align:center'
        }
      } else {
        return 'text-align:center'
      }
    },
    //table勾选事件
    handleSelectionChange(val) {
      this.selectedVal = val
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 170
      }, delay || 0)
    },
    //表格排序
    // sortChange(row) {
    //   let props = row.prop;
    //   switch (row.order) {
    //     case "descending":
    //       this.loadData(props, "DESC");
    //       break;
    //     case "ascending":
    //       this.loadData(props, "ASC");
    //       break;
    //     case null:
    //       break;
    //   }
    // },
    //table数据加载
    loadData() {
      this.tableData = []
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      if (this.code) {
        params.querys = [
          {
            group: 'advance',
            value: this.code,
            relation: 'OR',
            operation: 'LIKE',
            property: 'heading'
          }
        ]
      }
      // if (prop) {
      //   params.sorter = [{ property: prop, direction: sort }];
      // }
      this.$http.post('${business}/system/sys_bulletin/query', params).then((res) => {
        let response = res.data
        this.total = response.total
        this.tableData = response.rows
        this.$refs.ecoTable.doLayout()
      })
    },
    //表单预览
    preview(row) {
      this.noticeFrom = {
        subject: row.heading,
        content: row.body
      }
      this.noticeShow = true
    },
    closeNotice() {
      this.noticeShow = false
    }
  }
}
</script>

<style scoped>
/deep/.el-main {
  padding: 16px 10px;
}
.top_search {
  padding-bottom: 10px;
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
}
.button-group {
  height: 45px;
  text-align: left;
  width: 100%;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.col_style p {
  flex-shrink: 0;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}
/deep/.el-tabs__item.is-active {
  color: #fff !important;
  border: 0;
  border-radius: 5px;
  background: url(../../../assets/img/tabBg.png) no-repeat center;
  background-size: 98% 40px;
}
/deep/.el-tabs__active-bar {
  background-color: #fff;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: #fff;
}
/deep/.el-tabs__item {
  padding: 5px 15px !important;
  color: #101010 !important;
  line-height: normal !important;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0px 0px 5px 0px;
}
/deep/.el-table--scrollable-y .el-table__body-wrapper {
  overflow-y: auto;
  max-height: !important;
}
</style>
